<div class="sorter-filter-cont">
  <app-box-filter
    [individualFilter]="individualFilter"
    [index]="index"
    [label]="'HOTELS_MODULE.RESULT_HOTELS.SORTER_LABEL' | transloco"
    [show]="isOpenBox"
    (toggleShow)="toggleCheckboxOptions()">
    <div class="sorter-list"
      [class.collapsible]="collapseList"
      [class.active]="isOpenBox"
      [class.full-view]="!this.collapsed">
      <ng-container *ngFor="let sorter of orderedOptions">
        <div class="radio">
          <app-ds-radio-button
            [checked]="isChecked(sorter.OrderCriteriaAux)"
            [align]="radioButtonAlign"
            [title]="{ Label: getSorterTitle(sorter) | transloco: { code: getCodePlace(sorter) } }"
            [icon]="sorterIcon(sorter)"
            (radioOnChecked)="changeSortOption(sorter)">
          </app-ds-radio-button>
        </div>
      </ng-container>
    </div>
    <ng-container *ngIf="collapseList">
      <div class="see-more-cont">
        <div class="see-more" (click)="collapsibleListAction()">
          <app-ds-typography
            [fontFamily]="fontFamily.SemiBold"
            [size]="fontSize.XXS"
            [color]="fontColor.Primary"
            [text]="(collapsed ? 'SEE_MORE' : 'SEE_LESS') | transloco">
          </app-ds-typography>
        </div>
      </div>
    </ng-container>
  </app-box-filter>
</div>